import { useTranslation } from 'react-i18next';

import {
  LoadingContainer,
  LoadingIconWrapper,
  LoadingSpinner,
  LoadingContent,
  LoadingText,
  LoadingProgress,
  LoadingProgressBar
} from './LoadingView.styles';

interface LoadingViewProps {
  fileName?: string;
  progress?: number;
}

export const LoadingView: React.FC<LoadingViewProps> = ({ fileName, progress = 50 }) => {
  const { t } = useTranslation();

  return (
    <LoadingContainer>
      <LoadingIconWrapper>
        <LoadingSpinner />
      </LoadingIconWrapper>
      <LoadingContent>
        <LoadingText>{fileName || t('DefaultTranslations:UPLOADING')}</LoadingText>
        <LoadingProgress>
          <LoadingProgressBar progress={progress} />
        </LoadingProgress>
      </LoadingContent>
    </LoadingContainer>
  );
};
